import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#000";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    alignItems: "center",
    // height: 24,
    fontStyle: "bold",
  },
  stack: {
    flexDirection: "column",
  },
  stackHorizontal: {
    flexDirection: "row",
  },

  description: {
    width: "60%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  header: {
    fontSize: 16,
    // fontWeight: "10",
  },
  qty: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  amount: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
});

function secondsToHours(seconds) {
  return (seconds / 3600).toFixed(2);
}

const InvoiceTableRow = ({ items }) => {
  let itemsKeys = Object.keys(items);
  let itemsValues = Object.values(items);

  const rows = itemsValues.map((item, index) => (
    <View style={styles.row} key={index}>
      <View style={styles.description}>
        <Text style={styles.header}>{item.date}</Text>
        {item.data.map((item, index) => (
          <View style={styles.stackHorizontal}>
            <Text>{item.client}: </Text>
            <Text>{secondsToHours(item.seconds)}</Text>
          </View>
        ))}
      </View>
      <Text style={styles.qty}>{secondsToHours(item.seconds)}</Text>
      <Text style={styles.rate}>{item.rate}</Text>
      <Text style={styles.amount}>{item.amount.toFixed(2)}</Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

export default InvoiceTableRow;
